module.exports = __webpack_public_path__ + "media/images/plans/wedding_compact/hall-list/plan-wedding-lineup-kyushu-1-e5cc01b906e3de8c7bcf6f5246647048.png";